import React from 'react';

const AppContext = React.createContext({
    displayBrandCampaign: false,
});

export default AppContext;
